<template>
  <v-container>
    <v-breadcrumbs class="pa-0 ma-0" :items="breadcrumbs"></v-breadcrumbs>
    <!-- {{ this.otes }} -->
    <v-row >
      <v-col v-for="mov in otes" :key="mov.Id" cols="12" md="4">
        <v-card outlined>
          <v-alert :type="getTipoAlerta(mov.EstadoAutorizacion)" dense text border="left" class="pa-1 text-caption">
            {{ mov.EstadoAutorizacion }}
          </v-alert>
          <v-card-title class="headline blue--text">
            {{ mov.Referencia }}
          </v-card-title>
          <v-card-subtitle class="grey--text">
            {{ formatFecha(mov.created_at) }}
          </v-card-subtitle>
          <v-card-text>
            <div><strong>Tipo:</strong> {{ mov.Tipo }}</div>
            <div><strong>Solicitante:</strong> {{ mov.Solicitante }}</div><br />
            <!-- <div><strong>Estado:</strong> {{ mov.EstadoAutorizacion }}</div> -->
            <v-textarea v-model="mov.Descripcion" label="Descripción" readonly outlined rows="8" auto-grow
              color="blue"></v-textarea>
            <v-textarea v-model="mov.Comentarios" label="Comentarios" outlined clearable rows="3" auto-grow
              color="blue">
            </v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="azul_med" dark @click="autorizar(mov, 'Autorizado')">Autorizar</v-btn>
               <v-btn color="red" dark @click="autorizar(mov, 'Rechazar')">Rechazar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import formatFecha from '@/mixins/formatFecha';
import upperCase from '@/mixins/upperCase';
import { mapGetters } from 'vuex'

export default {
  mixins: [formatFecha, upperCase],
  components: {
    //FromOt: () => import('@/components/ordenservicio/fromOt.vue'),
  },
  computed: {
    ...mapGetters(['getIDE']),
    breadcrumbs() {
      return [
        { text: 'Visor membresias', disabled: false, href: `/visor-membresias/${this.id}` },
        { text: this.$route.meta.title || this.$route.name, disabled: true }
      ];
    }
  },
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
  },
  created() {
    this.ObtieneOrdenes()
  },
  data() {
    return {
      otes: []
    };
  },
  methods: {
    ObtieneOrdenes() {
      this.$http.get(`ordenservicio/pendientes`)
        .then(response => {
          if (response.status === 200) {
            if (response.data) {
              this.otes = response.data
            }
          }
        })
        .catch(() => {
        });
    },
    getTipoAlerta(estado) {
      switch (estado) {
        case "Pendiente":
          return "error"; // rojo claro
        case "Autorizado":
          return "success"; // verde
        case "Rechazado":
          return "warning"; // ámbar
        default:
          return "info";
      }
    },
    autorizar(ot, opcion){
        this.$http.put(`ordenservicio/${ot.Id}`,
          {
            AutorizadoPor: this.getIDE,
            EstadoAutorizacion: opcion,
            ComentarioAutorizacion: ot.Comentarios,
            Id: null,
            Referencia:'',
            Descripcion: null,
            CodMov:'',
            FecAutorizacion:null,
            user_id: '',
          }
          , {
        headers: {
          'Content-Type': 'application/json'
        }}
      )
        .then(response => {
          if (response.status === 200) {
            if (response.data) {
              //this.otes = response.data
              this.ObtieneOrdenes()
            }
          }
        })
.catch(err => console.error('Error:', err));
    }
  },
};
</script>
